import SmoothScroll from "smooth-scroll";

export default function () {
	var scroll = new SmoothScroll('a[href*="#"]', {
		speed: 200
	});
}
